var _style, _defs, _defs2, _defs3, _g, _g2, _defs4, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPricingBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 295 500",
    style: {
      enableBackground: "new 0 0 295 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:url(#SVGID_00000129186456031005855640000013455019083488702097_);}\t.st1{filter:url(#Adobe_OpacityMaskFilter);}\t.st2{fill:url(#SVGID_00000009590687483429785900000013470529196945156736_);}\t.st3{mask:url(#SVGID_00000039840379126231668890000015799435013656255158_);}\t.st4{opacity:0.5;clip-path:url(#SVGID_00000135667017629075437420000001038513111908962198_);}\t.st5{fill:#FFFFFF;}\t.st6{fill:#BCBCBC;}\t.st7{fill:#9D9D9D;}\t.st8{fill:#DADADA;}\t.st9{fill:#808080;}\t.st10{opacity:0.76;fill:url(#SVGID_00000165955883481084768930000007858197857450681778_);}\t.st11{opacity:0.78;fill:url(#SVGID_00000144297659861881518400000015204701830556677018_);}\t.st12{opacity:0.78;fill:url(#SVGID_00000040542853138396197970000011779963765450426027_);}\t.st13{opacity:0.1;}")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.75
    },
    width: 367,
    height: 563,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAXAAAAI0CAYAAAAEOHLYAAAACXBIWXMAAAsSAAALEgHS3X78AAAg AElEQVR4nO3dXXYbN7aAUfiXSQ+gR+H5j8Sj6AHcbjqJfR8s2BAEFFBkFQlU7b0WFynZpqg8fDo5 BKkQAAAAAGh49+wH0OvLly/TPFZgfl+/fv3x7MfQMmQU74z1kN8TMIybwzxa1IeIXSPYax/jEN8T MKy1ES7+/RFi/tTYFcJdejytxyjYwD1aIS79+avPPSvmD49fI9pr/qz1eYAetfj+WPg71T97ZMwf Fr8s3KXbS5/rmdSXPg+QWhPt3s+9uv2IkO8evEq4e66XIi7oQK+lkLYm6zzYPzr+7NXtPUO+W+BW hDuP9dLn0n+b33frcwCtfXYt1KWPe2K+a8g3D11HuGux7r2U7jf/erWPgfNpPgkZlsO99lK7v80j vmngFuLduryv3M4/zu+v9n0IN1CyJtwhhPA9+9z3jtut6XyzkG8WuiTeS2uSUqjfJ5d3hdu3TuO1 zwHnsmZtUrp8T65bt1sx/3W9RcTvDtyKqbsW7A/Z50qX0v2kX6f3+xF0OIfes9098S7F+p/sz5aC vhTzu0J+V9A6451P1HmwPySfy69L03ltEq99P6IN57Y0gdcCnkY4j/U/jetS0HeJ+M1xa8Q7X5Wk Qc6DnV4+huWY1yJe+l6EG0iV9t+1nXce4jTSrUsp5qWQv3pMt0T849p/EEJ3vEtTdinWtevSZF6K eAh9kzhAvvturU1q0f67cf0uuX73cj8huf94+114+4Ol200BT6QBzeNam7DTUH9KPpdf8n9bWqfE ry3gQI9WwNNpuRbu0uXDy/X75DqNePT95c/eRPzLly/v1k7hq0NXOW1SmrpjwGuB/pRdSkFvRXxp jSLiQKp18qT0RGUt3H8l16Xb6SVfr5RWKr8e05qIr5rAK/HOn6xMJ++laH/OrvOY5yEvrVLWHCkE WHrycmn6TsOdX769XC8NmbnqJL7mm7llhVLaeS/FO4/z54VLMeKXy6U0hd8ScGGHc6iFcFXAr9dr utsuhftb+Nmpb+H1oPkt1OMdfc/+/EcIPwfl3im8O2jZ9F2avEu77nzS/hxCuLxcPheuP4cQPl0u lzziPQH3gh4g1zpCWAp4epLk1drker3m8b4m19fsc9/C6wk9X6nkp1RenVDpifjaCbwW79LOO5+2 L8nlj+zjy+VyKU3itTVK6ThhKFyHysfAOZSODubXpdMn+WmTv0IIf18ul28hhG/X6zUG+lP4Gex0 0MyHzNbje5fcDmHFKqUrbJXpuzZ556uSPNzp5RJC+ONyuaRTeWmVsmYCL31fAg7ndGvAv4fXRwPj CuVbcrler9drCOF/L5f0dvw4nczjJP5X6JvEm1N4cwJfWJ2UnrjM994x4Gm0/4zXl8vlj/B2Is8D nr/Ap/QkQShcpwQczqn3VZitEyjp7jsG+dPlcvkYQvhwvV7TATMfKmvnzdNLaVrfbIWST7et1Uka 7xjoP9PL5XKJIU+n8TUB79l/CzcQwvIkXprCaydQvoWfjbqGZM17uVxixPPBsifeacRfPc7WE5qL AS+84rJ3hZLHOwb8X+FnvP8Vkkk8+Xv5Hjx/ErP1asxQuA0QLZ0Fz9//pBTwPN6/2nS5XN5fr9f8 VEntjHntyctVU3jPBN4b8aXVSTp5/yu8hDy5xAk8DXi8v7VHCPPbAFHPi3lqe/A4gVfbdLlc3v1c i7+639J7qqSX9+FtyH9ZmsLXrFB6dt/56ZNX65Mk3mnE8xXK0hOY6eSdvpQ+vS49duC8es6EL51G iRN4/orx0t47XC6XH9frtbaOKb0FbbyUdueLJ1KqAc/WJyGUI15bn7xZobzsvOMapRbw0v67tj5J H1P6GAFa8km8tQuPEc9ftFPaeX+/XC7fr9drzzsXfgjliHe9MrM1gbdOnpTWJ29WKC+nTf6sXGLA 8/VJvKQvoU8n8FC4rn0PwHktRbB3Cv8Yfr9pVd6jkN3H9/Az4v8kEc/fH+VjeB3y2NPiE5q1Ncqt L+RZetn8qxfvvMQ7vyztv/MnL2u/1CEUrgHWyAMeQvkJxxjvWotC8m9Kbzlbe6Or2NAY8dIqJX2c rxQD3rE+qUW8dISw9AKeN6/EDMvTd37qxBOXwD1qT2bG6zzi8W1iSyfgqscPL5fL38nL7+Pl08t1 nOp73vyqaGkCr72AZ+m9T15N4S8vjy+FvBbv2u679AOk9DgBerQCHtcZacCXpu7S9J2+b0psXDzF UnuFeT6FL65Renbg6e2eM+D5FJ5H/HP2Z/lbyi69p4AX7QBb6H2JfQzqPy+fL53TTuMdw30JL+G+ XC6fr9dr7d1W0/d4Sn+DT9ca5U3AV65PWscI17x1bG337dQJsLU8jOk6JF7nZ7JLQc2PG34OhYiH eryXNg1NtzyJmUa1+v7fyVvC5lN27Rc49PzmnVC4BrhHuqrIj/CV3qckfv5jeD19p/F+9Tbal8vl 0/V6rQW89h5PzTVK7wqlNIG/C6+jW/v1aa1fnZa+10nrDavCwm2Arb0Lv3fg0YeX6xjvpd59yj6/ 5u1BmmoBr028S2uU2q9QK/2uy9I30ftug/nt0mMHKKmdCU9XKHlD4h48PrEZ/15sXjwnvqZ/a39J zd0vpY/XebzfPKH58haLS5d8cvc+38Aj1JrxI/vzPORpxOPHpQG2NMjmW4a8e7X+xcdT2tH/ehCt b7Z2Scf+0gNrXWo7n9o3UToRA7CFnsbUNhCliL9ZLcf3Dg/lobW0Rmk27lXACydQ8gff+ibSnyat cOcvRy29wrJ0W7iBvbTCvbRKrh2vXjPEhlBu7S9pp1sTeO2byx98bSde+uZK/6b2Hyf/2gCPUBom 48elLUQt4KWhttbDpf4V9QR86adP6xupPTm5tO/pfbIS4FFqK5b32e2lqJcG2JvCHa2dwPMHv7S7 Xtrr9Ezc+dcDeKTaSnfNbrw2Ya9pY9WtK5T8m6s9+NIDXVrS1/63BWAkPRuJnqDn97XKUsCX1hml L9w7lS/99MrvO/+6AI9UWu+WJvI1/VuatFeFvHcCvyXePQ9SnIGZ1EJ7aw9bQ3Lpa/1y6w48t7QO SW+3HjTATGpxvWXQTf9dfruo9xRK60GFwudD4fbS/ZrIgZmtifEmzSsFfI+QCjNwFD2bhNoQW9tW 3DSFr1mh1Cbp3gfZ9YDu+LsAI9l6Vfymq1vswHv+N6H25wCjWzt01p6ArN0ufa2ur7nVk5gA9Nls qF17jLB2veY+AI7uIb3bcwJf+gZu+QEAMKJ7e3bzgLz3CsXxQOCsasetN7NXwAUbYGf3BFykAfr1 rJVXcQoFYFICDjApAQeYlIADTErAASYl4ACTEnCASQk4wKQEHGBSAg4wKQEHmJSAA0xKwAEmJeAA kxJwgEkJOMCkBBxgUgIOMCkBB5iUgANMSsABJiXgAJMScIBJCTjApAQcYFICDjApAQeYlIADTErA ASYl4ACTEnCASQk4wKQEHGBSAg4wKQEHmJSAA0xKwAEmJeAAkxJwgEkJOMCkBBxgUgIOMCkBB5iU gANMSsABJiXgAJMScIBJCTjApAQcYFICDjApAQeYlIADTErAASYl4ACTEnCASQk4wKQEHGBSAg4w KQEHmJSAA0xKwAEmJeAAkxJwgEkJOMCkdgn49Xrd424BSOw2gV+vVyEH2NHuKxQRB9jHQ3bgIg6w vYc9iWmlArCth59CEXGAbTzlGKFpHOB+Tz0HLuIAt3v6C3lM4wC3eXrAIxEHWGeYgIcg4gBrDBXw EKxUAHoNF/BIxAGWDRvwEEzjAEuGDngk4gBvTRHwEEzjALlpAh6JOMBP0wU8BBEHCGGngF8ulz3u 9hUrFeDsdpvAL5fLw0IOcEa7r1BM4wD7eMgO3DQOsL2HPolpGgfYzsNPoTwi4iGYxoHje8oxQisV gPs99Ry4lQrA7Z7+Qh7TOMBtnh7wyDQOsM4wAQ/BNA6wxlABj0zjAG1DBjwExw0BWoYNeAhWKgBL hg54ZKUC8NYUAQ/BNA6QmybgkWkc4KfpAh6CaRwghEkDHpnGgTObOuAhOG4InNf0AQ/BSgU4p0ME PLJSAc7kUAEPwTQOnMfhAh6ZxoGjO2zAQzCNA8d26IBHpnHgiE4R8BAcNwSOZ5eAjxoxKxXgSHab wEdeKVipAEew+wpl1IiZxoHZPWQHPvI0ahoHZvXQJzFHjZhpHJjRw0+hjBwx0zgwk6ccIxw5YqZx YBZPPQc+csREHBjd01/IM/o0vreRv39gbE8PeDRqxKxUgFENE/AQxp5GTePAaIYKeDRqxEzjwEiG DHgIY0fMNA6MYNiAhzB2xEzjwLPtEvCt4zZyxEQceJZdJ/CtIz5qyKxUgGfYfYVylmncSgV4tIft wE3j2xn5+wce56FPYm4dt1EjZhoHHuHhp1DOslIJwTQO7OtpxwjPtFIxjQN7eOo5cNP4tkb+QQZs b4gX8pxpGn+EUb9/YFtDBDyE80zjVirAVnYJ+D3xMI1vZ+TvH7jfbhP4PfFw3HBbo37/wH12X6Hc E/EzrFRCMI0Dt3nIDtxKpc00Dqz1sCcx712pmMa3M/IPMqDfw0+hmMbbHDcEejzlGKFpvM1KBWh5 6jlw03iblQpQ8/QX8pjG20zjQMnTAx6NNI2PyjQOpIYJeAhjRXzUiJnGgWiogIdgpdLLNA4MF/DI NN7muCGc27ABD8E03sNKBc5r6IBHpvE2KxU4nykCHoJpvIdpHM5lmoBHI03jozKNwzlMF/AQxor4 qBEzjcPxTRnwEKxUepnG4bimDXhkGm9z3BCOafqAh2Aa72GlAsdziIBHpvE2KxU4jkMFPATTeA/T OBzD4QIejTSNj8o0DnM7bMBDGCvio0bMNA7zOnTAQ7BS6WUah/kcPuCRabzNcUOYy2kCHoJpvIeV CszjVAGPTONtViowvlMGPATTeA/TOIzttAGPRprGR2UahzGdPuAhjBXxUSNmGofxCPgLK5U+pnEY h4BnTONtjhvCGAS8wDTeZqUCzyfgC0zjbVYq8DwC3mAabzONw3MIeCfTeJtpHB5LwFcYJeIhjDuN msbhcQR8JSuVPqZx2J+A32iUaXzkiDluCPsS8DuYxtusVGA/Ar4B03iblQpsT8A3YhpvM43DtgR8 Y6bxNtM4bEPAdzBKxEMYdxo1jcP9BHwnVip9TONwOwHf2SjT+MgRM43DbQT8AUzjfUQc1hHwBzKN t1mpQD8BfzDTeJuVCvQR8CcxjbeZxmGZgD/RvdP41o9lRKZxqBPwAViptJnG4S0BH4SVSptpHF4T 8IF4grOPiMNPAj4g03iblQoI+LBM421WKpydgA/ONN5mGuesBHwCjhu2mcY5IwGfiJVKm2mcMxHw yViptJnGOQsBn5AnOPuYxjk6AZ+YabztEREPYewfZByXgE/ONN5mpcJRCfhBmMbbrFQ4GgE/EMcN 20zjHImAH5CVSptpnCMQ8IOyUmkzjTM7AT8wT3D2MY0zKwE/AdN4m+OGzEjAT8I03malwmwE/GRM 421WKsxCwE/INN5mGmcGAn5iI03jozKNMzIBP7mRIj5qxEzjjErAsVLpZBpnNALOL6bxNscNGYmA 84ppvM1KhVEIOEWm8TYrFZ5NwKkyjbeZxnkmAadppGl8VKZxnkHA6TJSxEeNmGmcRxNwulmp9DGN 8ygCzmqm8TbHDXkEAecmpvE2KxX2JuDcxTTeZqXCXgScu5nG20zj7EHA2cxI0/ioTONsScDZ1EgR HzVipnG2IuBszkqlj2mcewk4uzGNtzluyD0EnF2ZxtusVLiVgPMQpvE2KxXWEnAexjTeZhpnDQHn 4UaaxkdlGqeHgPMUI0V81IiZxmkRcJ7GSqWPaZwaAefpTONtjhtSIuAMwTTeZqVCTsAZimm8zUqF SMAZjmm8zTROCALOwEzjbabxcxNwhjZKxEMYdxo1jZ+XgDM8K5U+pvHzEXCmMco0PnLEHDc8FwFn KqbxNiuV8xBwpmQab7NSOT4BZ1qm8TbT+LEJONMzjbeZxo9JwDmEUSIewrjTqGn8eAScw7BS6WMa Pw4B53BGmcZHjphp/BgEnEMyjfcR8bkJOIdmGm+zUpmXgHN4pvE2K5U5CTinYRpvM43PRcA5lXun 8a0fy4hM4/MQcE7JSqXNND4+Aee0rFTaTONjE3BOzROcfUR8TAIOwTTew0plPAIOL0zjbVYqYxFw yJjG20zjYxBwKHDcsM00/nwCDgusVNpM488j4NBgpdJmGn8OAYcOnuDsI+KPJeCwgmm8zUrlcQQc VjKNt1mpPIaAw41M422m8X0JONzBccM20/h+BBw2YKXSZhrfnoDDRqxU2kzj2xJw2JAnOPuYxrch 4LAD03jbIyIewtg/yO4l4LAT03iblcp9BBx2Zhpvs1K5jYDDAzhu2GYaX0/A4YGsVNpM4/0EHB7M SqXNNN5HwOEJPMHZxzS+TMDhiUzjbY4b1gk4PJlpvM1KpUzAYRCm8TYrldcEHAZiGm8zjf8m4DCg kabxUZnGBRyGNVLER43Y2adxAYeBWan0Oes0LuAwAdN42xmPGwo4TMI03na2lYqAw2RM421nWakI OEzINN52hmlcwGFiI03jozryNC7gMLmRIj5qyI86jQs4HICVSp+jTeMCDgdiGm870nFDAYeDMY23 HWWlIuBwUKbxtkeuVPb4byDgcGCm8bZHTeN7EHA4gZGm8VHNGHEBh5MYKeKjhny2aVzA4USsVPrM EnEBhxMyjbfNEHEBh5MyjbeNvlIRcDg503jbqBEXcMA03mHEaVzAgV9M420jRVzAgVdGiXgIpvEW AQfesFLp8+yICzhQNco0bqVSJuDAItN427NWKgIOdDGNtz064gIOdDONtz1yGhdwYDXTeNsjIi7g wE1GiXgI553GBRy4mZVKn70iLuDA3UaZxs+2UhFwYBOm8ccTcGBTpvHHEXBgc6bxxxBwYDem8X0J OLCre6fxrR/LkQg48BBWKtsTcOBhrFS2JeDAQ3mCczsCDjyFafx+Ag48jWn8PgIOPJ1p/DYCDgzB ccP1BBwYipVKPwEHhmOl0kfAgSF5grNNwIGhmcbrBBwYnmm8TMCBaZjGXxNwYCqOG/4m4MCUrFQE HJjY2VcqAg5M7cxPcAo4cAhnnMYFHDiMs03jAg4czlmmcQEHDmm044Z7hFzAgUMbZaWyBwEHDm+U lcrWBBw4hZGe4NyKgAOncqRpXMCB0znKNC7gwGnNPo0LOHBqM0/jAg4Q5pzGBRzgxWwRF3CAxEwr FQEHKJhhGhdwgIrRp3EBB2gYdRoXcIAOI07jAg6wwrN/E31KwAFWGiXiAg5wg2f9JvqUgAPc4ZkR F3CAOz1rGhdwgI08OuICDrChR07jAg6wg0dEXMABdrJ3xD/ueu8AJ7dnxE3gAJMScIBJCTjApAQc YFICDjApAQeYlIADTErAASYl4ACTEnCASQk4wKQEHGBSAg4wKQEHmJSAA0xKwAEmJeAAkxJwgEkJ OMCkBBxgUgIOMCkBB5iUgANMSsABJiXgAJMScIBJCTjApAQcYFICDjApAQeYlIADTErAASYl4ACT EnCASQk4wKQEHGBSAg4wKQEHmJSAA0xKwAEmJeAAkxJwgEkJOMCkBBxgUgIOMCkBB5iUgANMSsAB JiXgAJMScIBJCTjApAQcYFICDjApAQeYlIADTErAASYl4ACTEnCASQk4wKQEHGBSAg4wKQEHmJSA A0xKwAEmJeAAkxJwgEkJOMCkBBxgUgIOMCkBB5iUgANMSsABJiXgAJMScIBJCTjApAQcYFICDjAp AQeYlIADTErAASYl4ACTEnCASQk4wKQEHGBSAg4wqXsC/mOzRwFwfEvNvKmne03g4g6ws71XKD+S C8CZ/Ag7N3DPgPf874KwA7O7t2f5v+++v96A3/wFCvcBcHQP6Z1TKACP9aNye7UtAr70YPLdjykc mM3aTUPevB+N26Wv1fU11wR86Y5LD6z2AKxdgDPYenh909VSwPd4xlSIgaMoDaml7UMIfcNt/vnu 8PdM4KU7Kx2PyT+39KBK9+u4ITCzNSHepHlbPYnZivTSTyDRBmbVs8vuvaT/Lr9dtPYYYeuB5Z8v /b3S3wGYQe1JyDWhLjUxNG4XW7kU8J47bz2w740HnN9Hft/51wV4pNouO2SfX9O/1gTe3by1K5Se YKeXHwvXtZiHwucBRtIb7ryJ37M/z+9rlS3ejbD206Yn5kuTef41AB5paeLO/15vsPNe9kzpVR87 v4nWT5r0eunSmsTzB/yu4/EB7K20Uq5N26UW/hPqLewOdm6LFUrpgf4TXj/of7LPL4XdWgV4tlp3 agNsqYG1DvZM6F29exXwr1+/Lv2j0sqk9qDzSy3wtXi3/uMB7KG1ImkNsHkL/w59Xaz1783jSTvd WqH0rE5aD/zv7FL6CRTv631y/SP8XqHEB5x/nH4O4BZLz7/ln2tFuxTsvH9LQ+zSIY83enbg6QOv /eQpPeBavNPPf3z5+H34GeLvL9elB/8uvA15KPy9UPg7AD3/957vueP10vN9Pd2rTeL5frz0vGAI laDXAp6Gsra4z5fzeZz/Knwj6efi3/0Qfgb8/cvn0vC+C2/39PljqoXaqgXo0XreLY922rxatNPe lVpYm8RLe/Bqy3pWKOlEXPsJVHrw8YGXLp9erj+E1wF/9/INRXGlUot0HnOAW9Qm77R7ebjzzi01 76/s7/U8F9j0If/Ef/7zn/Dvf//7XfgZxxjOePt9dvmQXD5WLh+y6/zfvy98rSWl/9AAtyptGXrW xWmUry+X/71c//fl9n+zy/+Sv/Pt5ZJvJvLnB3/JD5r07sDjN9Z60jL9hr5VLh/Dzwk8Rj3/YZF+ vXhJVyl57Eu7coCapSct0wm4tDqptS69fc2uv4W3E3hpjbL6GOFSwPM9eO2nUul/J+KDvoYQPr9c fwq/w51P4vnpkh/h92SfrnFqk3rtNkCu9n/xecTTgJee48sH1Wvldivi6Xpm6cjiG72vxEwDW/qJ lP/vRB7xNN6lvXfI7v9j8jXy0JfWOykBB5YsPWnZWp2k8b6Gt6uTdEUSL3nEl57IrB4jLL1Opxjw r1+//vjy5UsprLU1Sj59x2DHeKf78HjJ1yb514gRz/fuSwEXb6BHz5OW+UGN2t47DXfpkoa8NoGv Ov8drZnASz+dSv9bEffctScy8xCH8Haq//RynQf/fXYdCtc14g7n0gph6ax17Zx3HvC4XUhD/d/C 7aUpvPco4SbHCGuxTVcoMdQx4h+ySynctf9VSeMfT6zkEQ/h7SQv1MCS0qmTEN4e5ysdG8zXwzHY /xd+Rjtel6bwfIWy9Mr05vokhIWAN9YopScx34fXZ7vzcOf77vQ+0x8En8PvV2mmT3iWpvfWPjwl 7HAuSxN4be9dG1BjcGOE89VJGu94XZrCS2fBS09gth5/CKF/hZLejt9gfOl7fCl8fFVlHvHS/jqq PUHwObxdweQBtw8H1ujZe9eODaYBj5f0zHe85PHOz3zXzn3X1iaLEV8MeMeTmfGl7zGsf4f2qZH0 PuKDL71yMz8vXvthUPoakYgDIZRPnixN36XBMg14+gRmjHVpjZL+vaUnMIsv3Alh+V1i17yZVekb TyfwNKI9AS/9hPucXGqnV9ZM4WHhc8DxleK3Zvqu7b9rT2KWXnmZTuC3vBdKVVfYXqbw/JK+HD5d d8T4XpLLH4XLny/Xl+Q6jXfp7HjPFL70fQk5nEMtfj27795Xmefnv/8b3p5GKZ1Eab0nyq9L43c0 rH4pff5xvkp59/LAQqg/YVl7E6xv4fUEXlqh1E6k9O7BBRzOodSr/HZpAs/fXbW2QsnXKPk0nsZ9 zfnvVWfBu4OWTOHx36VrjPxNrdIJOgb5snD5HN5O4KWz5KUJPD8TLuBAK+A9Z79LbxObT+B5yP+X fb73VZjp4wihY/oOYd0EHr/Z0vuWfE/+ztIbU9Vevfk5vJ7A0+l7aYWyNIHbhcN5tXbf8bq0GVja gedTeCnmebRr8a69+rJr+g5hZdCSEylL+/D0EiNcmsjT2+nH6b+pvYqz9kRmKFzf/X0D0+g9+x2v axN4/grM/Bc0pHHOY52/cVUt3rUVSuv3E/+ydgJP5T8xvmcfL/2UK72D4adQfrvZ2vrklhUKcE5r Vyj5GqUU8dLbyZaiXYt3cefdG+8QVgY8ORceVynxC8U3nYoRXzp2WNovlXbepd13+nL80ouDBBwo WQp42qb0YMbSLrz223jS6zT+Pb+Bpzvc0U2By1Yp8Tp/YjMNbv5beXp/g0/p9EntDPiaFQpwPks7 8HwSL51Gyafx2iUPd3p/i/FeM32HcEfkVkS8th8vRb12ye/LKzGBNWrHoJfOgpee0FwKeunPS6+0 3CTeIdy3A49K65TSy+Zra5QP4ff7qKSTdi3crXiLOJCqHSlcE/G0WbWo55P7UrhvXpuk7opb9j4p SydUShN5ac2Sf64W7qXdt1dhAiHU45gHPL39PbSn8fx2adJeCvebeN8yfYewQdQ6I74U86W4L73v yZpXYObEHI6pFcLSeeulSXxpIs8j3Yr2pvEOYcOQVXbi8Xop5LXrnnD3xluw4ZxKcVwT8VLI88+V rpeiffPOO7dp2Bam8Xi9FPOez+X3U/o6+dcHCGF5Fx6v0+CWYtz7uWq4Q9gm3iHsFLnCNB5vt2K+ 9Gf3hFvM4ZxaE3j6cc80XtqbL/3Zq6+xVbij3cJWmcbT27Vw124vhVu0gZY165R4XYtyLeS1+9w8 3iE8IHKdIe+9vjXaYg7n1DqJUvvc0gqkdf3q9h7hjh4WtoWQpx/3xr50H6X7A0gtxXRpGu/581cf 7xnu6OGhy0JeegxLH4s2sJW1Me/6+BHhjp4avULMQ7h9ny3gwBo9oe15EvSh0U4NE71KzKNbHucw 3xswhFsiW/03z4p2atjINYLeY9jvDXiKu4I7QrBz00Vug7ADVI0YagAAYAT/Dy7C2egAAAAESURB VM0vQJ662yFHAAAAAElFTkSuQmCC",
    transform: "matrix(1 0 0 1 -42.4876 -30.4876)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M-18.1,9.8v474.3c0,13,10.5,23.5,23.5,23.5h278.8c13,0,23.5-10.5,23.5-23.5V9.8       c0-13-10.5-23.5-23.5-23.5H5.4C-7.5-13.7-18.1-3.1-18.1,9.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000177447023550921515370000011717051821433616520_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050664669379088363850000015201453217517681032_",
    gradientUnits: "userSpaceOnUse",
    x1: -254.6786,
    y1: -25.668,
    x2: 237.6889,
    y2: 389.8481,
    gradientTransform: "matrix(6.123234e-17 -1 1 6.123234e-17 -29.9583 229.8652)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEBFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4513,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6FFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000050664669379088363850000015201453217517681032_)"
    },
    d: "M-18.1,9.8v474.3     c0,13,10.5,23.5,23.5,23.5h278.8c13,0,23.5-10.5,23.5-23.5V9.8c0-13-10.5-23.5-23.5-23.5H5.4C-7.5-13.7-18.1-3.1-18.1,9.8z"
  }), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    x: -25.4,
    y: -122.8,
    width: 346.3,
    height: 692.5
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -25.4,
    y: -122.8,
    width: 346.3,
    height: 692.5,
    id: "SVGID_00000014610029718991985100000010794425926159140754_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121249084189713958740000009111374831801001125_",
    gradientUnits: "userSpaceOnUse",
    x1: -21.4174,
    y1: 20.5735,
    x2: -13.6531,
    y2: 300.0933,
    gradientTransform: "matrix(6.123234e-17 -1 1 6.123234e-17 -29.9583 229.8652)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121249084189713958740000009111374831801001125_)"
    },
    d: "M-18.1,9.8v474.3       c0,13,10.5,23.5,23.5,23.5h278.8c13,0,23.5-10.5,23.5-23.5V9.8c0-13-10.5-23.5-23.5-23.5H5.4C-7.5-13.7-18.1-3.1-18.1,9.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#SVGID_00000014610029718991985100000010794425926159140754_)"
    }
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000047776200111587640850000005605076693643531396_",
    d: "M-18.1,9.8v474.3c0,13,10.5,23.5,23.5,23.5h278.8       c13,0,23.5-10.5,23.5-23.5V9.8c0-13-10.5-23.5-23.5-23.5H5.4C-7.5-13.7-18.1-3.1-18.1,9.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000046305737854091189600000007638353186883714491_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047776200111587640850000005605076693643531396_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      clipPath: "url(#SVGID_00000046305737854091189600000007638353186883714491_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "9.3,396.6 -8,413.9 -25.3,396.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "-25.3,431.2 -8,413.9 9.3,431.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "9.3,396.6 9.3,431.2 -8,413.9         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "-25.3,500.5 -8,483.2 9.3,500.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "9.3,465.9 -8,483.2 -25.3,465.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "9.3,465.9 9.3,500.5 -8,483.2         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "9.3,292.7 -8,310 -25.3,292.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "-25.3,327.3 -8,310 9.3,327.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "9.3,292.7 9.3,327.3 -8,310         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "9.3,258.1 -8,275.4 -25.3,258.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "-25.3,292.7 -8,275.4 9.3,292.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "9.3,258.1 9.3,292.7 -8,275.4         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "9.3,223.5 -8,240.8 -25.3,223.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "-25.3,258.1 -8,240.8 9.3,258.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "9.3,223.5 9.3,258.1 -8,240.8         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "9.3,327.3 -8,344.7 -25.3,327.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "-25.3,362 -8,344.7 9.3,362         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "9.3,327.3 9.3,362 -8,344.7         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "9.3,362 -8,379.3 -25.3,362         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "-25.3,396.6 -8,379.3 9.3,396.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "9.3,362 9.3,396.6 -8,379.3         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "-25.3,465.9 -8,448.5 9.3,465.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "9.3,431.2 -8,448.5 -25.3,431.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "9.3,431.2 9.3,465.9 -8,448.5         "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "43.9,223.5 26.6,240.8 9.3,223.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "9.3,258.1 26.6,240.8 43.9,258.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "43.9,223.5 43.9,258.1 26.6,240.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "9.3,258.1 9.3,223.5 26.6,240.8         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "43.9,258.1 26.6,275.4 9.3,258.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "9.3,292.7 26.6,275.4 43.9,292.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "43.9,258.1 43.9,292.7 26.6,275.4         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "9.3,292.7 9.3,258.1 26.6,275.4         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "9.3,396.6 26.6,379.3 43.9,396.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "43.9,362 26.6,379.3 9.3,362         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "9.3,396.6 9.3,362 26.6,379.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "43.9,362 43.9,396.6 26.6,379.3         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "43.9,292.7 26.6,310 9.3,292.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "9.3,327.3 26.6,310 43.9,327.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "43.9,292.7 43.9,327.3 26.6,310         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "9.3,327.3 9.3,292.7 26.6,310         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "9.3,500.5 26.6,483.2 43.9,500.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "43.9,465.9 26.6,483.2 9.3,465.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "9.3,500.5 9.3,465.9 26.6,483.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "43.9,465.9 43.9,500.5 26.6,483.2         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "9.3,465.9 26.6,448.5 43.9,465.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "43.9,431.2 26.6,448.5 9.3,431.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "9.3,465.9 9.3,431.2 26.6,448.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "43.9,431.2 43.9,465.9 26.6,448.5         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "9.3,431.2 26.6,413.9 43.9,431.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "43.9,396.6 26.6,413.9 9.3,396.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "9.3,431.2 9.3,396.6 26.6,413.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "43.9,396.6 43.9,431.2 26.6,413.9         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "43.9,327.3 26.6,344.7 9.3,327.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "9.3,362 26.6,344.7 43.9,362         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "43.9,327.3 43.9,362 26.6,344.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "9.3,362 9.3,327.3 26.6,344.7         "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "320.8,223.5 303.5,240.8 286.2,223.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "286.2,258.1 303.5,240.8 320.8,258.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "286.2,258.1 286.2,223.5 303.5,240.8         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "320.8,258.1 303.5,275.4 286.2,258.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "286.2,292.7 303.5,275.4 320.8,292.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "286.2,292.7 286.2,258.1 303.5,275.4         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "286.2,396.6 303.5,379.3 320.8,396.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "320.8,362 303.5,379.3 286.2,362         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "286.2,396.6 286.2,362 303.5,379.3         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "320.8,292.7 303.5,310 286.2,292.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "286.2,327.3 303.5,310 320.8,327.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "286.2,327.3 286.2,292.7 303.5,310         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "286.2,500.5 303.5,483.2 320.8,500.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "320.8,465.9 303.5,483.2 286.2,465.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "286.2,500.5 286.2,465.9 303.5,483.2         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "286.2,465.9 303.5,448.5 320.8,465.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "320.8,431.2 303.5,448.5 286.2,431.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "286.2,465.9 286.2,431.2 303.5,448.5         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "286.2,431.2 303.5,413.9 320.8,431.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "320.8,396.6 303.5,413.9 286.2,396.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "286.2,431.2 286.2,396.6 303.5,413.9         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "320.8,327.3 303.5,344.7 286.2,327.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "286.2,362 303.5,344.7 320.8,362         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "286.2,362 286.2,327.3 303.5,344.7         "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "286.2,396.6 268.9,413.9 251.6,396.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "251.6,431.2 268.9,413.9 286.2,431.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "286.2,396.6 286.2,431.2 268.9,413.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "251.6,431.2 251.6,396.6 268.9,413.9         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "251.6,500.5 268.9,483.2 286.2,500.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "286.2,465.9 268.9,483.2 251.6,465.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "251.6,500.5 251.6,465.9 268.9,483.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "286.2,465.9 286.2,500.5 268.9,483.2         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "286.2,292.7 268.9,310 251.6,292.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "251.6,327.3 268.9,310 286.2,327.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "286.2,292.7 286.2,327.3 268.9,310         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "251.6,327.3 251.6,292.7 268.9,310         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "286.2,258.1 268.9,275.4 251.6,258.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "251.6,292.7 268.9,275.4 286.2,292.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "286.2,258.1 286.2,292.7 268.9,275.4         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "251.6,292.7 251.6,258.1 268.9,275.4         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "286.2,223.5 268.9,240.8 251.6,223.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "251.6,258.1 268.9,240.8 286.2,258.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "286.2,223.5 286.2,258.1 268.9,240.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "251.6,258.1 251.6,223.5 268.9,240.8         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "286.2,327.3 268.9,344.7 251.6,327.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "251.6,362 268.9,344.7 286.2,362         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "286.2,327.3 286.2,362 268.9,344.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "251.6,362 251.6,327.3 268.9,344.7         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "286.2,362 268.9,379.3 251.6,362         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "251.6,396.6 268.9,379.3 286.2,396.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "286.2,362 286.2,396.6 268.9,379.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "251.6,396.6 251.6,362 268.9,379.3         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "251.6,465.9 268.9,448.5 286.2,465.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "286.2,431.2 268.9,448.5 251.6,431.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "251.6,465.9 251.6,431.2 268.9,448.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "286.2,431.2 286.2,465.9 268.9,448.5         "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "113.1,223.5 95.8,240.8 78.5,223.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "78.5,258.1 95.8,240.8 113.1,258.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "113.1,223.5 113.1,258.1 95.8,240.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "78.5,258.1 78.5,223.5 95.8,240.8         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "113.1,258.1 95.8,275.4 78.5,258.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "78.5,292.7 95.8,275.4 113.1,292.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "113.1,258.1 113.1,292.7 95.8,275.4         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "78.5,292.7 78.5,258.1 95.8,275.4         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "78.5,396.6 95.8,379.3 113.1,396.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "113.1,362 95.8,379.3 78.5,362         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "78.5,396.6 78.5,362 95.8,379.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "113.1,362 113.1,396.6 95.8,379.3         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "113.1,292.7 95.8,310 78.5,292.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "78.5,327.3 95.8,310 113.1,327.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "113.1,292.7 113.1,327.3 95.8,310         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "78.5,327.3 78.5,292.7 95.8,310         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "78.5,500.5 95.8,483.2 113.1,500.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "113.1,465.9 95.8,483.2 78.5,465.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "78.5,500.5 78.5,465.9 95.8,483.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "113.1,465.9 113.1,500.5 95.8,483.2         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "78.5,465.9 95.8,448.5 113.1,465.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "113.1,431.2 95.8,448.5 78.5,431.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "78.5,465.9 78.5,431.2 95.8,448.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "113.1,431.2 113.1,465.9 95.8,448.5         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "78.5,431.2 95.8,413.9 113.1,431.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "113.1,396.6 95.8,413.9 78.5,396.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "78.5,431.2 78.5,396.6 95.8,413.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "113.1,396.6 113.1,431.2 95.8,413.9         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "113.1,327.3 95.8,344.7 78.5,327.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "78.5,362 95.8,344.7 113.1,362         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "113.1,327.3 113.1,362 95.8,344.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "78.5,362 78.5,327.3 95.8,344.7         "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "78.5,396.6 61.2,413.9 43.9,396.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "43.9,431.2 61.2,413.9 78.5,431.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "78.5,396.6 78.5,431.2 61.2,413.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "43.9,431.2 43.9,396.6 61.2,413.9         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "43.9,500.5 61.2,483.2 78.5,500.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "78.5,465.9 61.2,483.2 43.9,465.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "43.9,500.5 43.9,465.9 61.2,483.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "78.5,465.9 78.5,500.5 61.2,483.2         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "78.5,292.7 61.2,310 43.9,292.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "43.9,327.3 61.2,310 78.5,327.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "78.5,292.7 78.5,327.3 61.2,310         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "43.9,327.3 43.9,292.7 61.2,310         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "78.5,258.1 61.2,275.4 43.9,258.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "43.9,292.7 61.2,275.4 78.5,292.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "78.5,258.1 78.5,292.7 61.2,275.4         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "43.9,292.7 43.9,258.1 61.2,275.4         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "78.5,223.5 61.2,240.8 43.9,223.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "43.9,258.1 61.2,240.8 78.5,258.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "78.5,223.5 78.5,258.1 61.2,240.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "43.9,258.1 43.9,223.5 61.2,240.8         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "78.5,327.3 61.2,344.7 43.9,327.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "43.9,362 61.2,344.7 78.5,362         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "78.5,327.3 78.5,362 61.2,344.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "43.9,362 43.9,327.3 61.2,344.7         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "78.5,362 61.2,379.3 43.9,362         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "43.9,396.6 61.2,379.3 78.5,396.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "78.5,362 78.5,396.6 61.2,379.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "43.9,396.6 43.9,362 61.2,379.3         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "43.9,465.9 61.2,448.5 78.5,465.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "78.5,431.2 61.2,448.5 43.9,431.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "43.9,465.9 43.9,431.2 61.2,448.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "78.5,431.2 78.5,465.9 61.2,448.5         "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "251.6,223.5 234.3,240.8 217,223.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "217,258.1 234.3,240.8 251.6,258.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "251.6,223.5 251.6,258.1 234.3,240.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "217,258.1 217,223.5 234.3,240.8         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "251.6,258.1 234.3,275.4 217,258.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "217,292.7 234.3,275.4 251.6,292.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "251.6,258.1 251.6,292.7 234.3,275.4         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "217,292.7 217,258.1 234.3,275.4         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "217,396.6 234.3,379.3 251.6,396.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "251.6,362 234.3,379.3 217,362         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "217,396.6 217,362 234.3,379.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "251.6,362 251.6,396.6 234.3,379.3         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "251.6,292.7 234.3,310 217,292.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "217,327.3 234.3,310 251.6,327.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "251.6,292.7 251.6,327.3 234.3,310         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "217,327.3 217,292.7 234.3,310         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "217,500.5 234.3,483.2 251.6,500.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "251.6,465.9 234.3,483.2 217,465.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "217,500.5 217,465.9 234.3,483.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "251.6,465.9 251.6,500.5 234.3,483.2         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "217,465.9 234.3,448.5 251.6,465.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "251.6,431.2 234.3,448.5 217,431.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "217,465.9 217,431.2 234.3,448.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "251.6,431.2 251.6,465.9 234.3,448.5         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "217,431.2 234.3,413.9 251.6,431.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "251.6,396.6 234.3,413.9 217,396.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "217,431.2 217,396.6 234.3,413.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "251.6,396.6 251.6,431.2 234.3,413.9         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "251.6,327.3 234.3,344.7 217,327.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "217,362 234.3,344.7 251.6,362         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "251.6,327.3 251.6,362 234.3,344.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "217,362 217,327.3 234.3,344.7         "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "217,396.6 199.7,413.9 182.4,396.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "182.4,431.2 199.7,413.9 217,431.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "217,396.6 217,431.2 199.7,413.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "182.4,431.2 182.4,396.6 199.7,413.9         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "182.4,500.5 199.7,483.2 217,500.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "217,465.9 199.7,483.2 182.4,465.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "182.4,500.5 182.4,465.9 199.7,483.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "217,465.9 217,500.5 199.7,483.2         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "217,292.7 199.7,310 182.4,292.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "182.4,327.3 199.7,310 217,327.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "217,292.7 217,327.3 199.7,310         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "182.4,327.3 182.4,292.7 199.7,310         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "217,258.1 199.7,275.4 182.4,258.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "182.4,292.7 199.7,275.4 217,292.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "217,258.1 217,292.7 199.7,275.4         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "182.4,292.7 182.4,258.1 199.7,275.4         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "217,223.5 199.7,240.8 182.4,223.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "182.4,258.1 199.7,240.8 217,258.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "217,223.5 217,258.1 199.7,240.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "182.4,258.1 182.4,223.5 199.7,240.8         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "217,327.3 199.7,344.7 182.4,327.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "182.4,362 199.7,344.7 217,362         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "217,327.3 217,362 199.7,344.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "182.4,362 182.4,327.3 199.7,344.7         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "217,362 199.7,379.3 182.4,362         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "182.4,396.6 199.7,379.3 217,396.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "217,362 217,396.6 199.7,379.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "182.4,396.6 182.4,362 199.7,379.3         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "182.4,465.9 199.7,448.5 217,465.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "217,431.2 199.7,448.5 182.4,431.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "182.4,465.9 182.4,431.2 199.7,448.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "217,431.2 217,465.9 199.7,448.5         "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "147.7,396.6 130.4,413.9 113.1,396.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "113.1,431.2 130.4,413.9 147.7,431.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "147.7,396.6 147.7,431.2 130.4,413.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "113.1,431.2 113.1,396.6 130.4,413.9         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "113.1,500.5 130.4,483.2 147.7,500.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "147.7,465.9 130.4,483.2 113.1,465.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "113.1,500.5 113.1,465.9 130.4,483.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "147.7,465.9 147.7,500.5 130.4,483.2         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "147.7,292.7 130.4,310 113.1,292.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "113.1,327.3 130.4,310 147.7,327.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "147.7,292.7 147.7,327.3 130.4,310         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "113.1,327.3 113.1,292.7 130.4,310         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "147.7,258.1 130.4,275.4 113.1,258.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "113.1,292.7 130.4,275.4 147.7,292.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "147.7,258.1 147.7,292.7 130.4,275.4         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "113.1,292.7 113.1,258.1 130.4,275.4         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "147.7,223.5 130.4,240.8 113.1,223.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "113.1,258.1 130.4,240.8 147.7,258.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "147.7,223.5 147.7,258.1 130.4,240.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "113.1,258.1 113.1,223.5 130.4,240.8         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "147.7,327.3 130.4,344.7 113.1,327.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "113.1,362 130.4,344.7 147.7,362         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "147.7,327.3 147.7,362 130.4,344.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "113.1,362 113.1,327.3 130.4,344.7         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "147.7,362 130.4,379.3 113.1,362         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "113.1,396.6 130.4,379.3 147.7,396.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "147.7,362 147.7,396.6 130.4,379.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "113.1,396.6 113.1,362 130.4,379.3         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "113.1,465.9 130.4,448.5 147.7,465.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "147.7,431.2 130.4,448.5 113.1,431.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "113.1,465.9 113.1,431.2 130.4,448.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "147.7,431.2 147.7,465.9 130.4,448.5         "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "182.4,223.5 165,240.8 147.7,223.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "147.7,258.1 165,240.8 182.4,258.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "182.4,223.5 182.4,258.1 165,240.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "147.7,258.1 147.7,223.5 165,240.8         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "182.4,258.1 165,275.4 147.7,258.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "147.7,292.7 165,275.4 182.4,292.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "182.4,258.1 182.4,292.7 165,275.4         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "147.7,292.7 147.7,258.1 165,275.4         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "147.7,396.6 165,379.3 182.4,396.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "182.4,362 165,379.3 147.7,362         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "147.7,396.6 147.7,362 165,379.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "182.4,362 182.4,396.6 165,379.3         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "182.4,292.7 165,310 147.7,292.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "147.7,327.3 165,310 182.4,327.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "182.4,292.7 182.4,327.3 165,310         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "147.7,327.3 147.7,292.7 165,310         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "147.7,500.5 165,483.2 182.4,500.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "182.4,465.9 165,483.2 147.7,465.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "147.7,500.5 147.7,465.9 165,483.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "182.4,465.9 182.4,500.5 165,483.2         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "147.7,465.9 165,448.5 182.4,465.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "182.4,431.2 165,448.5 147.7,431.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "147.7,465.9 147.7,431.2 165,448.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "182.4,431.2 182.4,465.9 165,448.5         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "147.7,431.2 165,413.9 182.4,431.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "182.4,396.6 165,413.9 147.7,396.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "147.7,431.2 147.7,396.6 165,413.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "182.4,396.6 182.4,431.2 165,413.9         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "182.4,327.3 165,344.7 147.7,327.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "147.7,362 165,344.7 182.4,362         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "182.4,327.3 182.4,362 165,344.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "147.7,362 147.7,327.3 165,344.7         "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "286.3,188.8 303.6,206.1 286.3,223.4         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "320.9,223.4 286.3,223.4 303.6,206.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "286.3,188.8 320.9,188.8 303.6,206.1         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "286.3,223.4 268.9,206.1 286.3,188.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "251.6,188.8 268.9,206.1 251.6,223.4         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "286.3,223.4 251.6,223.4 268.9,206.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "251.6,188.8 286.3,188.8 268.9,206.1         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "147.7,188.8 165.1,206.1 147.7,223.4         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "182.4,223.4 165.1,206.1 182.4,188.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "147.7,188.8 182.4,188.8 165.1,206.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "182.4,223.4 147.7,223.4 165.1,206.1         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "251.6,223.4 234.3,206.1 251.6,188.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "217,188.8 234.3,206.1 217,223.4         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "251.6,223.4 217,223.4 234.3,206.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "217,188.8 251.6,188.8 234.3,206.1         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "43.8,188.8 61.2,206.1 43.8,223.4         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "78.5,223.4 61.2,206.1 78.5,188.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "43.8,188.8 78.5,188.8 61.2,206.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "78.5,223.4 43.8,223.4 61.2,206.1         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "9.2,188.8 26.5,206.1 9.2,223.4         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "43.8,223.4 26.5,206.1 43.8,188.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "9.2,188.8 43.8,188.8 26.5,206.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "43.8,223.4 9.2,223.4 26.5,206.1         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "9.2,223.4 -8.1,206.1 9.2,188.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "-25.4,188.8 9.2,188.8 -8.1,206.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "9.2,223.4 -25.4,223.4 -8.1,206.1         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "78.5,188.8 95.8,206.1 78.5,223.4         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "113.1,223.4 95.8,206.1 113.1,188.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "78.5,188.8 113.1,188.8 95.8,206.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "113.1,223.4 78.5,223.4 95.8,206.1         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "113.1,188.8 130.4,206.1 113.1,223.4         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "147.7,223.4 130.4,206.1 147.7,188.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "113.1,188.8 147.7,188.8 130.4,206.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "147.7,223.4 113.1,223.4 130.4,206.1         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "217,223.4 199.7,206.1 217,188.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "182.4,188.8 199.7,206.1 182.4,223.4         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "217,223.4 182.4,223.4 199.7,206.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "182.4,188.8 217,188.8 199.7,206.1         "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "9.2,188.8 -8.1,171.4 9.2,154.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "-25.4,154.1 9.2,154.1 -8.1,171.4         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "9.2,188.8 -25.4,188.8 -8.1,171.4         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "9.2,154.1 26.5,171.4 9.2,188.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "43.8,188.8 26.5,171.4 43.8,154.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "9.2,154.1 43.8,154.1 26.5,171.4         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "43.8,188.8 9.2,188.8 26.5,171.4         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "147.7,188.8 130.4,171.4 147.7,154.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "113.1,154.1 130.4,171.4 113.1,188.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "147.7,188.8 113.1,188.8 130.4,171.4         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "113.1,154.1 147.7,154.1 130.4,171.4         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "43.8,154.1 61.2,171.4 43.8,188.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "78.5,188.8 61.2,171.4 78.5,154.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "43.8,154.1 78.5,154.1 61.2,171.4         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "78.5,188.8 43.8,188.8 61.2,171.4         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "251.6,188.8 234.3,171.4 251.6,154.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "217,154.1 234.3,171.4 217,188.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "251.6,188.8 217,188.8 234.3,171.4         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "217,154.1 251.6,154.1 234.3,171.4         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "286.3,188.8 268.9,171.4 286.3,154.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "251.6,154.1 268.9,171.4 251.6,188.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "286.3,188.8 251.6,188.8 268.9,171.4         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "251.6,154.1 286.3,154.1 268.9,171.4         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "286.3,154.1 303.6,171.4 286.3,188.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "320.9,188.8 286.3,188.8 303.6,171.4         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "286.3,154.1 320.9,154.1 303.6,171.4         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "217,188.8 199.7,171.4 217,154.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "182.4,154.1 199.7,171.4 182.4,188.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "217,188.8 182.4,188.8 199.7,171.4         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "182.4,154.1 217,154.1 199.7,171.4         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "182.4,188.8 165.1,171.4 182.4,154.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "147.7,154.1 165.1,171.4 147.7,188.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "182.4,188.8 147.7,188.8 165.1,171.4         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "147.7,154.1 182.4,154.1 165.1,171.4         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "78.5,154.1 95.8,171.4 78.5,188.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "113.1,188.8 95.8,171.4 113.1,154.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "78.5,154.1 113.1,154.1 95.8,171.4         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "113.1,188.8 78.5,188.8 95.8,171.4         "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "286.3,-18.9 303.6,-1.6 286.3,15.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "320.9,15.7 286.3,15.7 303.6,-1.6         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "286.3,15.7 268.9,-1.6 286.3,-18.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "251.6,-18.9 268.9,-1.6 251.6,15.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "286.3,15.7 251.6,15.7 268.9,-1.6         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "147.7,-18.9 165.1,-1.6 147.7,15.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "182.4,15.7 165.1,-1.6 182.4,-18.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "182.4,15.7 147.7,15.7 165.1,-1.6         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "251.6,15.7 234.3,-1.6 251.6,-18.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "217,-18.9 234.3,-1.6 217,15.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "251.6,15.7 217,15.7 234.3,-1.6         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "43.8,-18.9 61.2,-1.6 43.8,15.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "78.5,15.7 61.2,-1.6 78.5,-18.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "78.5,15.7 43.8,15.7 61.2,-1.6         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "9.2,-18.9 26.5,-1.6 9.2,15.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "43.8,15.7 26.5,-1.6 43.8,-18.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "43.8,15.7 9.2,15.7 26.5,-1.6         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "9.2,15.7 -8.1,-1.6 9.2,-18.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "9.2,15.7 -25.4,15.7 -8.1,-1.6         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "78.5,-18.9 95.8,-1.6 78.5,15.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "113.1,15.7 95.8,-1.6 113.1,-18.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "113.1,15.7 78.5,15.7 95.8,-1.6         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "113.1,-18.9 130.4,-1.6 113.1,15.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "147.7,15.7 130.4,-1.6 147.7,-18.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "147.7,15.7 113.1,15.7 130.4,-1.6         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "217,15.7 199.7,-1.6 217,-18.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "182.4,-18.9 199.7,-1.6 182.4,15.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "217,15.7 182.4,15.7 199.7,-1.6         "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "286.3,119.5 303.6,136.8 286.3,154.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "320.9,154.1 286.3,154.1 303.6,136.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "286.3,119.5 320.9,119.5 303.6,136.8         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "286.3,154.1 268.9,136.8 286.3,119.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "251.6,119.5 268.9,136.8 251.6,154.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "286.3,154.1 251.6,154.1 268.9,136.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "251.6,119.5 286.3,119.5 268.9,136.8         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "147.7,119.5 165.1,136.8 147.7,154.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "182.4,154.1 165.1,136.8 182.4,119.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "147.7,119.5 182.4,119.5 165.1,136.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "182.4,154.1 147.7,154.1 165.1,136.8         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "251.6,154.1 234.3,136.8 251.6,119.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "217,119.5 234.3,136.8 217,154.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "251.6,154.1 217,154.1 234.3,136.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "217,119.5 251.6,119.5 234.3,136.8         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "43.8,119.5 61.2,136.8 43.8,154.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "78.5,154.1 61.2,136.8 78.5,119.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "43.8,119.5 78.5,119.5 61.2,136.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "78.5,154.1 43.8,154.1 61.2,136.8         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "9.2,119.5 26.5,136.8 9.2,154.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "43.8,154.1 26.5,136.8 43.8,119.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "9.2,119.5 43.8,119.5 26.5,136.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "43.8,154.1 9.2,154.1 26.5,136.8         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "9.2,154.1 -8.1,136.8 9.2,119.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "-25.4,119.5 9.2,119.5 -8.1,136.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "9.2,154.1 -25.4,154.1 -8.1,136.8         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "78.5,119.5 95.8,136.8 78.5,154.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "113.1,154.1 95.8,136.8 113.1,119.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "78.5,119.5 113.1,119.5 95.8,136.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "113.1,154.1 78.5,154.1 95.8,136.8         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "113.1,119.5 130.4,136.8 113.1,154.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "147.7,154.1 130.4,136.8 147.7,119.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "113.1,119.5 147.7,119.5 130.4,136.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "147.7,154.1 113.1,154.1 130.4,136.8         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "217,154.1 199.7,136.8 217,119.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "182.4,119.5 199.7,136.8 182.4,154.1         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "217,154.1 182.4,154.1 199.7,136.8         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "182.4,119.5 217,119.5 199.7,136.8         "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "9.2,119.5 -8.1,102.2 9.2,84.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "-25.4,84.9 9.2,84.9 -8.1,102.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "9.2,119.5 -25.4,119.5 -8.1,102.2         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "9.2,84.9 26.5,102.2 9.2,119.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "43.8,119.5 26.5,102.2 43.8,84.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "9.2,84.9 43.8,84.9 26.5,102.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "43.8,119.5 9.2,119.5 26.5,102.2         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "147.7,119.5 130.4,102.2 147.7,84.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "113.1,84.9 130.4,102.2 113.1,119.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "147.7,119.5 113.1,119.5 130.4,102.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "113.1,84.9 147.7,84.9 130.4,102.2         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "43.8,84.9 61.2,102.2 43.8,119.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "78.5,119.5 61.2,102.2 78.5,84.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "43.8,84.9 78.5,84.9 61.2,102.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "78.5,119.5 43.8,119.5 61.2,102.2         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "251.6,119.5 234.3,102.2 251.6,84.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "217,84.9 234.3,102.2 217,119.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "251.6,119.5 217,119.5 234.3,102.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "217,84.9 251.6,84.9 234.3,102.2         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "286.3,119.5 268.9,102.2 286.3,84.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "251.6,84.9 268.9,102.2 251.6,119.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "286.3,119.5 251.6,119.5 268.9,102.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "251.6,84.9 286.3,84.9 268.9,102.2         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "286.3,84.9 303.6,102.2 286.3,119.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "320.9,119.5 286.3,119.5 303.6,102.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "286.3,84.9 320.9,84.9 303.6,102.2         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "217,119.5 199.7,102.2 217,84.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "182.4,84.9 199.7,102.2 182.4,119.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "217,119.5 182.4,119.5 199.7,102.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "182.4,84.9 217,84.9 199.7,102.2         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "182.4,119.5 165.1,102.2 182.4,84.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "147.7,84.9 165.1,102.2 147.7,119.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "182.4,119.5 147.7,119.5 165.1,102.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "147.7,84.9 182.4,84.9 165.1,102.2         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "78.5,84.9 95.8,102.2 78.5,119.5         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "113.1,119.5 95.8,102.2 113.1,84.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "78.5,84.9 113.1,84.9 95.8,102.2         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "113.1,119.5 78.5,119.5 95.8,102.2         "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "9.2,50.3 -8.1,33 9.2,15.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "-25.4,15.7 9.2,15.7 -8.1,33         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "9.2,50.3 -25.4,50.3 -8.1,33         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "9.2,15.7 26.5,33 9.2,50.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "43.8,50.3 26.5,33 43.8,15.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "9.2,15.7 43.8,15.7 26.5,33         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "43.8,50.3 9.2,50.3 26.5,33         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "147.7,50.3 130.4,33 147.7,15.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "113.1,15.7 130.4,33 113.1,50.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "147.7,50.3 113.1,50.3 130.4,33         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "113.1,15.7 147.7,15.7 130.4,33         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "43.8,15.7 61.2,33 43.8,50.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "78.5,50.3 61.2,33 78.5,15.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "43.8,15.7 78.5,15.7 61.2,33         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "78.5,50.3 43.8,50.3 61.2,33         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "251.6,50.3 234.3,33 251.6,15.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "217,15.7 234.3,33 217,50.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "251.6,50.3 217,50.3 234.3,33         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "217,15.7 251.6,15.7 234.3,33         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "286.3,50.3 268.9,33 286.3,15.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "251.6,15.7 268.9,33 251.6,50.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "286.3,50.3 251.6,50.3 268.9,33         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "251.6,15.7 286.3,15.7 268.9,33         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "286.3,15.7 303.6,33 286.3,50.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "320.9,50.3 286.3,50.3 303.6,33         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "286.3,15.7 320.9,15.7 303.6,33         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "217,50.3 199.7,33 217,15.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "182.4,15.7 199.7,33 182.4,50.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "217,50.3 182.4,50.3 199.7,33         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "182.4,15.7 217,15.7 199.7,33         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "182.4,50.3 165.1,33 182.4,15.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "147.7,15.7 165.1,33 147.7,50.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "182.4,50.3 147.7,50.3 165.1,33         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "147.7,15.7 182.4,15.7 165.1,33         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "78.5,15.7 95.8,33 78.5,50.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "113.1,50.3 95.8,33 113.1,15.7         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "78.5,15.7 113.1,15.7 95.8,33         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "113.1,50.3 78.5,50.3 95.8,33         "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "286.3,50.3 303.6,67.6 286.3,84.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "320.9,84.9 286.3,84.9 303.6,67.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "286.3,50.3 320.9,50.3 303.6,67.6         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "286.3,84.9 268.9,67.6 286.3,50.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "251.6,50.3 268.9,67.6 251.6,84.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "286.3,84.9 251.6,84.9 268.9,67.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "251.6,50.3 286.3,50.3 268.9,67.6         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "147.7,50.3 165.1,67.6 147.7,84.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "182.4,84.9 165.1,67.6 182.4,50.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "147.7,50.3 182.4,50.3 165.1,67.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "182.4,84.9 147.7,84.9 165.1,67.6         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "251.6,84.9 234.3,67.6 251.6,50.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "217,50.3 234.3,67.6 217,84.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "251.6,84.9 217,84.9 234.3,67.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "217,50.3 251.6,50.3 234.3,67.6         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "43.8,50.3 61.2,67.6 43.8,84.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "78.5,84.9 61.2,67.6 78.5,50.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "43.8,50.3 78.5,50.3 61.2,67.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "78.5,84.9 43.8,84.9 61.2,67.6         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "9.2,50.3 26.5,67.6 9.2,84.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "43.8,84.9 26.5,67.6 43.8,50.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "9.2,50.3 43.8,50.3 26.5,67.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "43.8,84.9 9.2,84.9 26.5,67.6         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "9.2,84.9 -8.1,67.6 9.2,50.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "-25.4,50.3 9.2,50.3 -8.1,67.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "9.2,84.9 -25.4,84.9 -8.1,67.6         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "78.5,50.3 95.8,67.6 78.5,84.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "113.1,84.9 95.8,67.6 113.1,50.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "78.5,50.3 113.1,50.3 95.8,67.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "113.1,84.9 78.5,84.9 95.8,67.6         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "113.1,50.3 130.4,67.6 113.1,84.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "147.7,84.9 130.4,67.6 147.7,50.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "113.1,50.3 147.7,50.3 130.4,67.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "147.7,84.9 113.1,84.9 130.4,67.6         "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "217,84.9 199.7,67.6 217,50.3         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "182.4,50.3 199.7,67.6 182.4,84.9         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "217,84.9 182.4,84.9 199.7,67.6         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "182.4,50.3 217,50.3 199.7,67.6         "
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177464410957052471250000018185353225937669309_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.7507,
    y1: -497.5283,
    x2: 88.853,
    y2: 269.1252,
    gradientTransform: "matrix(6.123234e-17 -1 1 6.123234e-17 -29.9583 229.8652)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00E2AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09190416,
    style: {
      stopColor: "#06E3AF",
      stopOpacity: 0.9081
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2175,
    style: {
      stopColor: "#18E5B5",
      stopOpacity: 0.7825
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3625,
    style: {
      stopColor: "#35E8BE",
      stopOpacity: 0.6375
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5221,
    style: {
      stopColor: "#5DEDCB",
      stopOpacity: 0.4779
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#90F2DB",
      stopOpacity: 0.3063
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#CEF9EF",
      stopOpacity: 0.1276
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.76,
      fill: "url(#SVGID_00000177464410957052471250000018185353225937669309_)"
    },
    d: "M307.7,9.8      c0-13-10.5-23.5-23.5-23.5H5.4c-13,0-23.5,10.5-23.5,23.5v78l325.8,227.7V9.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024707812075528481910000010801844219844244129_",
    gradientUnits: "userSpaceOnUse",
    x1: 114.7213,
    y1: -515.7695,
    x2: -17.1762,
    y2: 250.883,
    gradientTransform: "matrix(6.123234e-17 -1 1 6.123234e-17 -29.9583 229.8652)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00FFAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.78,
      fill: "url(#SVGID_00000024707812075528481910000010801844219844244129_)"
    },
    points: "307.7,335.1       -18.1,107.4 -18.1,132.8 307.7,360.5     "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080206534498144238010000000062227133971662740_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.2696,
    y1: -521.1829,
    x2: -48.6284,
    y2: 245.4718,
    gradientTransform: "matrix(6.123234e-17 -1 1 6.123234e-17 -29.9583 229.8652)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00FFAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.78,
      fill: "url(#SVGID_00000080206534498144238010000000062227133971662740_)"
    },
    points: "307.7,375.8       -18.1,148.1 -18.1,156.9 307.7,384.6     "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000074434741780002769050000001758331831853884084_",
    d: "M-18.1,9.8v474.3c0,13,10.5,23.5,23.5,23.5h278.8       c13,0,23.5-10.5,23.5-23.5V9.8c0-13-10.5-23.5-23.5-23.5H5.4C-7.5-13.7-18.1-3.1-18.1,9.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142875073676978310360000015576414286785835912_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000074434741780002769050000001758331831853884084_",
    style: {
      overflow: "visible"
    }
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M199.1,260.9c53.4-8.1,114-17.2,208.7-62.6l-0.3-0.5c-94.6,45.3-155.1,54.4-208.5,62.5   c-51.9,7.8-96.6,14.6-156,55.3c-54.9,37.6-94.2,61-103,66.1l0.3,0.5c8.8-5.2,48.1-28.6,103-66.2   C102.6,275.5,147.3,268.7,199.1,260.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M172,245.2c-52.8,2.2-98.5,4.2-153,41.5c-54.2,37.1-83.3,68.1-90.2,75.7l0.3,0.5c6.5-7.3,35.7-38.5,90.2-75.8   c54.4-37.2,99.9-39.1,152.7-41.4c56.6-2.4,120.3-5.1,207.5-55.3c5.8-3.3,11.7-6.9,17.7-10.7l-0.3-0.5   C300.6,239.7,232.3,242.6,172,245.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M27.3,296.8c55.6-38.1,100.6-41.5,152.8-45.6c58.2-4.5,124-9.6,220.6-65.2l-0.3-0.5   C304,241,238.2,246.1,180.1,250.6c-52.2,4-97.4,7.5-153.1,45.7c-54.4,37.2-86.9,65.8-94.4,72.6l0.3,0.5   C-59.8,362.8-27.3,334.2,27.3,296.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M51.3,325.7c62.3-42.6,105.3-50.7,159.9-61c48.3-9.1,108.4-20.5,200.2-60.2l-0.3-0.5   c-91.7,39.7-151.7,51-200,60.1c-54.6,10.3-97.7,18.4-160.1,61.1C-4.1,362.9-47,383.7-56.3,388.1l0.3,0.5   C-46.5,384.2-3.7,363.3,51.3,325.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M164.4,239.5c-51.3,0.4-99.8,0.9-153.4,37.5c-53.9,36.9-79.8,70.4-85.9,78.9l0.3,0.6   c5.8-8.1,31.6-41.8,85.9-79c53.4-36.5,101.8-37,153.1-37.4c55.9-0.5,118.4-1,199.3-47.6c9.7-5.6,19.6-11.8,29.9-18.8l-0.3-0.5   C297.7,238.3,226.9,238.9,164.4,239.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M457.2,284.1c-74.5-2.3-125.4,4.6-160.2,21.7c-32,15.7-47.6,38.2-65.6,64.1c-17.5,25.2-37.3,53.7-76.6,80.6   c-32.4,22.2-75.9,26.3-106.6,25.8c-27.3-0.4-49.7-4.4-57-5.9l0.4,0.7c7.9,1.5,29.9,5.4,56.6,5.8c30.8,0.5,74.4-3.6,107-25.9   c39.4-27,59.3-55.6,76.8-80.8c35.1-50.6,62.9-90.6,225.7-85.6L457.2,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M35,305.9c-54.6,37.4-90.5,63.4-98.7,69.4l0.3,0.5c8-5.9,44-31.9,98.7-69.4c57.2-39.1,101.9-44.2,153.7-50.1   c55.9-6.4,119.1-13.6,215.2-64.1l-0.3-0.5c-96,50.5-159.2,57.7-215,64.1C137.1,261.6,92.3,266.7,35,305.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M59.3,335.3c66.7-45.6,109-55.1,167.5-68.3c45.4-10.2,101.9-22.9,188.1-56.4l-0.3-0.5   c-86.1,33.5-142.6,46.2-188,56.3c-58.6,13.1-100.9,22.7-167.7,68.4c-55.3,37.8-101.6,56-111.6,59.6l0.3,0.5   C-42.1,391.2,4.2,373.1,59.3,335.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M-85.8,336.9c1.4-4.4,5-14.2,12.7-26.8c9.7-15.9,28.1-39.4,60.5-61.6c51.3-35.1,102.2-30.9,156.1-26.4   c35.6,3,72.5,6,112.2-1.7c26.4-5.1,51.8-14.7,76.6-29c17.1-9.8,33.9-21.9,50.6-36.3l-0.3-0.5c-92.1,79.2-170.2,72.7-239.1,67   c-54-4.5-105-8.7-156.5,26.5c-32.5,22.3-51,45.9-60.7,61.8c-7.4,12.1-11,21.7-12.6,26.4L-85.8,336.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M224,364.6c-18.2,23.5-38.9,50.1-77.2,76.3c-32.4,22.2-74.7,27.2-104.5,27.5c-26.3,0.3-47.8-3-54.9-4.3   l0.4,0.7c7.6,1.3,28.7,4.4,54.5,4.2c29.8-0.3,72.2-5.3,104.8-27.6c38.4-26.3,59.1-52.9,77.3-76.5c37.6-48.4,67.3-86.7,229.5-86.4   l-0.3-0.6c-74.3-0.1-125.5,7.7-160.8,24.5C260.2,318,243.4,339.6,224,364.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M66.9,344.5C11.5,382.4-38.4,397.9-49,400.9l0.3,0.5c10.9-3.1,60.7-18.6,115.9-56.4   c73.7-50.5,114.6-60.9,182.2-78.1c41.5-10.6,93.1-23.7,169-50l-0.3-0.5c-75.8,26.3-127.3,39.4-168.8,50   C181.6,283.5,140.8,294,66.9,344.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M150.3,227.6C97.2,224.8,47.1,222-5,257.7c-53.4,36.6-72.9,74.8-77.4,85.1l0.4,0.6   c4.2-9.7,23.4-48.3,77.4-85.3c51.9-35.5,101.9-32.8,154.9-29.9c34.5,1.9,70.1,3.8,109.2-4.2c27.9-5.7,54.9-16.1,81.6-31.5   c15.2-8.8,30.4-19.2,45.5-31.3l-0.3-0.5C292.7,235.3,217,231.3,150.3,227.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M105.6,363.4c-4.7,3.2-9.6,6.6-14.7,10.1C35.1,411.7-25.8,418.9-38,420l0.3,0.6c12.9-1.2,73.4-8.6,128.9-46.6   c5.1-3.5,10-6.9,14.7-10.1c105.4-72.4,119.3-81.8,323.2-128.5l-0.3-0.5c-97.4,22.3-155.1,36.9-198.5,54.7   C187.9,306.9,158.7,326.9,105.6,363.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M169.4,346.7c-17.3,13.4-36.9,28.5-62.5,46c-32.4,22.2-68.7,31.9-93.5,36c-21.5,3.6-38.2,3.9-44.1,3.8l0.3,0.6   c6.2,0,22.7-0.3,43.8-3.9c24.8-4.2,61.2-13.9,93.7-36.2c25.7-17.6,45.3-32.7,62.5-46.1c62.2-48.1,93.6-72.3,266.5-99.5l-0.3-0.5   C263,274.3,231.7,298.6,169.4,346.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M146.2,349.8c-13.6,9.8-29.1,20.8-47.3,33.3C43,421.4-21.6,425.8-34.3,426.3l0.3,0.6   c13.5-0.6,77.6-5.2,133.2-43.3c18.2-12.4,33.6-23.5,47.3-33.3c76.6-54.9,102.6-73.5,286.2-108.8l-0.3-0.5   c-90.7,17.5-143.9,31.1-183.2,47.2C209.8,304.2,184.5,322.3,146.2,349.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M157.2,233.6C105,232.4,55.8,231.2,3,267.3c-53.7,36.8-76.3,72.6-81.7,82l0.3,0.6c5-8.9,27.5-45,81.7-82.1   c52.6-36,101.8-34.8,153.8-33.6c33.3,0.8,67.8,1.6,106.1-6.7c29.8-6.4,58.8-17.8,87.9-34.5c12.9-7.4,25.8-16,38.8-25.6l-0.3-0.5   C295.1,236.8,221.8,235.1,157.2,233.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M82.9,363.8C27.2,401.9-30,411.9-41.6,413.6l0.3,0.5c12.2-1.8,69.1-11.9,124.6-49.9   c106.4-72.8,130.2-79.1,284.9-119.9c17.1-4.5,36.4-9.6,57.5-15.2l-0.3-0.5c-21,5.6-40.2,10.7-57.3,15.2   C213.2,284.6,189.4,290.9,82.9,363.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M74.9,354.1c-55.6,38-109.1,50.8-120.2,53.1l0.3,0.5c11.6-2.4,64.9-15.3,120.3-53.1   c85.8-58.8,120.5-68.2,213.2-93.4c34.4-9.4,77.3-21,133.6-38.2l-0.3-0.5c-56.3,17.2-99,28.8-133.5,38.2   C195.5,285.9,160.8,295.3,74.9,354.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M216.1,359.5c-18.8,21.7-40.1,46.4-77.2,71.8c-32.4,22.2-73.5,28.1-102.3,29.2c-25.3,0.9-45.8-1.6-52.7-2.6   l0.4,0.7c7.3,1.1,27.5,3.5,52.3,2.6c28.8-1.1,70-7,102.6-29.3c37.2-25.4,58.5-50.1,77.3-71.9c41.7-48.2,71.9-83,234-87.5l-0.3-0.6   c-74.4,2.1-125.9,10.8-161.8,27.4C254.9,314.6,236.9,335.4,216.1,359.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M207.3,354.8c-19.2,19.9-40.9,42.5-76.4,66.8c-32.4,22.2-72.3,29.1-100.1,30.9c-24.4,1.6-43.9-0.2-50.6-1   l0.4,0.6c7,0.8,26.3,2.6,50.2,1c27.8-1.9,67.8-8.7,100.4-31c35.5-24.3,57.3-46.9,76.5-66.9c44.4-46.1,76.6-79.5,239.2-89l-0.3-0.6   c-74.8,4.4-126.7,14.1-163.3,30.5C249.1,311.4,229.7,331.5,207.3,354.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M185.2,347.7c-18.8,15.9-40,33.9-70.3,54.6c-32.4,22.2-69.9,30.9-95.7,34.3c-22.4,3-40.1,2.5-46.2,2.2l0.4,0.6   c6.5,0.3,23.9,0.7,45.9-2.3c25.8-3.4,63.4-12.2,96-34.4c30.3-20.7,51.6-38.8,70.4-54.7c54.2-45.9,87-73.7,254.2-94.3l-0.3-0.6   C272.3,273.9,239.5,301.8,185.2,347.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M197.3,350.8c-19.3,18-41.1,38.4-74.4,61.3c-32.4,22.2-71.1,30-97.9,32.6c-23.4,2.3-42,1.2-48.4,0.6l0.4,0.6   c6.8,0.5,25.1,1.6,48.1-0.7c26.8-2.6,65.6-10.5,98.2-32.7c33.4-22.8,55.2-43.3,74.5-61.3c49.1-45.9,81.6-76.3,245.7-91.1l-0.3-0.6   C278.9,274.3,246.4,304.8,197.3,350.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingBackground);
export default __webpack_public_path__ + "static/media/PricingBackground.e69719bee065e3c1049ca9b22aec5274.svg";
export { ForwardRef as ReactComponent };